import { Create, useForm } from '@refinedev/antd';
import { HttpError } from '@refinedev/core';
import { Form, Input } from 'antd';
import type { Company } from '@viq-admin/types';
import { RequireCan } from '../../components/RequireCan';

/**
 * Create a company (i.e. a tenant). A company IS a tenant, so there is no
 * `companyId` field — the body is global (`{ name, entraHint }`). `manage
 * Company` gates the whole page via `RequireCan`.
 */
interface CreateCompanyInput {
  name: string;
  entraHint?: string | null;
}

export function CompanyCreate() {
  const { formProps, saveButtonProps, onFinish } = useForm<
    Company,
    HttpError,
    CreateCompanyInput
  >({ resource: 'companies', action: 'create' });

  return (
    <RequireCan I="manage" a="Company">
      <Create saveButtonProps={saveButtonProps}>
        <Form
          {...formProps}
          layout="vertical"
          onFinish={(values: CreateCompanyInput) =>
            onFinish({ name: values.name, entraHint: values.entraHint ?? null })
          }
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'Name is required' }]}
          >
            <Input maxLength={200} placeholder="Acme Corp" />
          </Form.Item>
          <Form.Item label="Entra Hint" name="entraHint">
            <Input maxLength={200} placeholder="acme.com" />
          </Form.Item>
        </Form>
      </Create>
    </RequireCan>
  );
}
